module.exports = __webpack_public_path__ + "static/media/Fight.2a34dd10.svg";